// Types
import {Category, CurrentSelectedCategory} from "interfaces/category";

// Utils
import { convertToSlug } from "utils/textFormat";

export const filterCategoryByVisibleTags = (activeFilters: CurrentSelectedCategory[]): CurrentSelectedCategory[] => {
	return activeFilters.filter(category => category.selectedTags.some(tag => isVisibleTag(tag)));
}

export const getMappedCategories = (categories: Category[]) => {
	return categories
		.map((category) => {
			const tags = category.tags
				.map((tag) => ({
					...tag,
					slugName: convertToSlug(tag.name),
					urlParameter: category.urlParameter
				}));
			return { ...category, tags, slugName: convertToSlug(category.name) };
		});
};

export const findTagCategoryById = (macroCategory: Category, idTag: number): Category | undefined => macroCategory.tags.find((category) => category.id === idTag && isReachableTag(macroCategory, category));

export const addActiveTagToList = (tagsActiveCurrently: Category[], tag: Category | undefined, id: number): number | undefined => {
	if (!tag) {
		//Tag not exists
		return undefined;
	} else {
		return tagsActiveCurrently.push(tag);
	}
};

export const findMacroCategory = (category: Category, allCategories: Category[]): Category => {
	return <Category>allCategories.find(macroCategory =>
		macroCategory.urlParameter == category.urlParameter &&
		macroCategory.tags.length > 0 &&
		macroCategory.tags.some(tag => tag.urlParameter === category.urlParameter)
	);
};

export const isVisibleTag = (tag: Category): boolean => tag.isVisibleAltX;
export const isReachableTag = (macroCategory: Category, tag: Category): boolean => macroCategory.isVisibleAltX && tag.isVisibleAltX || tag.seoUrl;
